import { Permissions } from 'src/api/requests'

import { useUser } from './useUser'

/** Who may correct an already recorded laboratory result. While the test is not
 *  approved — not yet sent to the requesting doctor — any laboratory user may
 *  edit it; once it is approved the correction needs a dedicated permission.
 *  Consultation access marks a doctor rather than laboratory staff, so it
 *  blocks editing outright regardless of approval state. */
export const useResultEditPermission = () => {
  const { hasPermission } = useUser()

  const hasConsultationAccess = hasPermission([
    Permissions.TREATMENT_MENU_ACCESS_CONSULTATIONS,
    Permissions.TREATMENT_MENU_ACCESS_PERSONAL_CONSULTATIONS
  ])

  const canEditApprovedResult = !!hasPermission(
    Permissions.INVESTIGATIONS_TESTS_EDIT_APPROVED_RESULT
  )

  const canEditResult = (isApproved?: boolean) =>
    !hasConsultationAccess && (!isApproved || canEditApprovedResult)

  return { canEditApprovedResult, canEditResult }
}
